import { toJS } from "mobx";
import { useEffect, useState } from "react";
import Button from "../../../components/Button";
import { useStore } from "../../../store";
import { BiWifi, BiWifi1, BiWifi2, BiBookmark } from "react-icons/bi";
import { IoCheckmarkOutline } from "react-icons/io5";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FaCircleExclamation } from "react-icons/fa6";
import "./index.css";
import { observer } from "mobx-react-lite";
import InputModal, { InputModalProps } from "../../../components/InputModal";
import WifiConnectingIcon from "../../../components/WifiConnectingIcon";

function MenuSettingWifi() {
  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;

  const [connectModal, setConnectModal] = useState<InputModalProps>({
    isOpen: false,
    title: "Enter Password:",
    value: "",
    password: true,
    onSave: (value: string) => { },
    onCancel: () => {
      setConnectModal((data) => ({ ...data, isOpen: false }));
    },
  });

  const [ssid, setSsid] = useState("");

  const wifis = (resData.loadWifiAck?.data || []).map((item, index) => {
    return ({
      ...item,
    })
  });


  const currentWifi = (wifis && wifis.find(item => item.ssid === ssid)) || null;

  let onClickChooseWifi = function (id: string) {
    setSsid(id);
  };

  let onClickDeleteWifi = function (id: string) {
    if (id) {
      dataStore.sendData({
        action: "deleteWifi",
        data: {
          ssid: id,
        },
      });
    }

  }

  return (
    <div className="w-4/6 relative mr-10 ">
      <div className="border-2 rounded-2xl absolute inset-0 m-auto h-5/6 opacity-1 mr-10 pr-4">
        <div className="">
          <div className="w-1/4 float-left h-[570px] pl-4 pt-4 border-r-2">
            <Button
              options={{
                text: "Wi-Fi",
                class: "bg-buttonRunBgColor text-lg px-8",
                cb: () => { },
              }}
              style={{
                padding: "0px 40px",
                backgroundColor: "#406F70",
                fontSize: "24px",
                width: "160px",
                margin: 10,
                marginLeft: 2,
                borderColor: "white",
                borderStyle: "solid",
                borderWidth: "2px",
                boxShadow: "inset 1px 1px 5px 5px #2d5253",
              }}
            ></Button>
          </div>
          <div className="h-[400px] w-3/4 pl-4 pt-4 overflow-auto mt-4 wifi-list-div">
            {resData.loadWifiSpinnerAck?.loading ? <AiOutlineLoading3Quarters className="load-icon text-white text-4xl h-4 w-4 ml-4" /> : undefined}

            {wifis.length ? (
              wifis.map((item, index) => {
                return (
                  <div className="" key={index}>
                    <div
                      className="text-white text-2xl h-10 w-3/4 float-left"
                      style={{
                        border:
                          ssid === item.ssid
                            ? "2px solid white"
                            : "2px solid transparent",
                        borderRadius: "20px",
                        paddingLeft: "15px",
                        paddingTop: "2px",
                        overflow: "hidden",           // 超出隐藏
                        textOverflow: "ellipsis",     // 超出显示省略号
                        whiteSpace: "nowrap",         // 强制单行
                      }}
                      onClick={() => onClickChooseWifi(item.ssid)}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "inline-block",
                          maxWidth: "calc(100% - 60px)"
                        }}
                      >
                        {index + 1}. {item.ssid }
                      </span>

                      {item.status === "CONNECTING" ? (
                        <AiOutlineLoading3Quarters
                          className="load-icon"
                          style={{
                            float: "right",
                            marginRight: "15px",
                            marginTop: "5px",
                          }}
                        />
                      ) : item.status === "CONNECTED" ? (
                        <IoCheckmarkOutline
                          style={{
                            float: "right",
                            marginRight: "15px",
                            marginTop: "5px",
                          }}
                        />
                      ) : null}

                    </div>

                    {item.status === "CONNECTING" ? (
                      <WifiConnectingIcon className="wifi-icon"></WifiConnectingIcon>
                    ) : (
                      <>
                        {item.signalQuality > 0 && item.signalQuality <= 30 ? (
                          <BiWifi1 className="wifi-icon" />
                        ) : null}
                        {item.signalQuality > 30 && item.signalQuality <= 60 ? (
                          <BiWifi2 className="wifi-icon" />
                        ) : null}

                        {item.signalQuality > 60 ? (
                          <BiWifi className="wifi-icon" />
                        ) : null}
                      </>
                    )}



                    {item.connected ? <BiBookmark className="exclamation-icon" /> : null}

                  </div>
                );
              })
            ) : (
              <AiOutlineLoading3Quarters className="load-icon text-white text-4xl ml-[250px] mt-[200px]" />
            )}


            {wifis.length ? (
              <>
                <Button
                  options={{
                    text: "Connect",
                    class:
                      "bg-buttonRunBgColor text-2xl px-8 absolute inset-0 m-auto",
                    cb: () =>
                      setConnectModal((data) => ({
                        ...data,
                        isOpen: true,
                        name: ssid,
                        onSave: (value: string) => {
                          dataStore.sendData({
                            action: "connectWifi",
                            data: {
                              ssid: ssid,
                              password: value,
                            },
                          });

                          setConnectModal((data) => ({
                            ...data,
                            isOpen: false,
                          }));
                        },
                      })),
                    disabled: currentWifi?.status === 'CONNECTED' || !currentWifi
                  }}
                  style={{
                    boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                    backgroundColor: "#406F70",
                    marginBottom: "50px",
                    width: '200px',
                    marginLeft: '250px'
                  }}
                />

                <Button
                  options={{
                    text: "Forget",
                    class:
                      "bg-buttonRunBgColor text-2xl px-8 absolute inset-0 m-auto",
                    cb: () => onClickDeleteWifi(currentWifi?.ssid || ""),
                    disabled: !(wifis.length && currentWifi && currentWifi?.status === 'CONNECTED')
                  }}
                  style={{
                    boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                    backgroundColor: "#406F70",
                    marginBottom: "50px",
                    width: '200px',
                    marginLeft: '500px'
                  }}
                /></>
            ) : null}



          </div>
        </div>
      </div>
      {connectModal.isOpen && <InputModal {...connectModal} />}
    </div>
  );
}
export default observer(MenuSettingWifi);
